import {
  CheckNotes,
  InspectionCase,
  InspectionTimeCase,
  InspectionTimeCaseDto,
  InspectionWaterSupplyDataCase,
  InspectionWaterSupplyDataCaseDto
} from '../../inspection-cases';

export class WaterFloodingSystemsDto extends InspectionCase {
  deploymentAccordingSpec?: InspectionCase;
  pipingDesignType?: InspectionCase;
  maxWaterNeededAtMainStation?: InspectionWaterSupplyDataCaseDto;
  maxWaterNeededAtSource?: InspectionWaterSupplyDataCaseDto;
  sprinklerOffTimeRequirenments?: InspectionTimeCaseDto;
  requiredPoolingVolume?: InspectionWaterSupplyDataCaseDto;
  floodingSystemOperationDescription?: InspectionCase;
  hydraulicWaterRequirementMatchWaterSupplyDesign?: InspectionCase;
}

export class WaterFloodingSystems extends WaterFloodingSystemsDto {
  constructor(data: WaterFloodingSystemsDto = { title: 'מערכות הצפה במים' }) {
    super(data);
    this.deploymentAccordingSpec = new InspectionCase({
      ...data.deploymentAccordingSpec,
      title: 'פריסת המתזים / נחירים מתאימה לדרישות התקן?'
    });
    this.pipingDesignType = new InspectionCase({
      ...data.pipingDesignType,
      title: 'סוג הצנרת שתוכנן'
    });
    this.maxWaterNeededAtMainStation = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtMainStation,
      title: 'דרישת המים המירבית הדרושה במבוא לתחנת ההפעלה הראשית'
    });
    this.maxWaterNeededAtSource = new InspectionWaterSupplyDataCase({
      ...data.maxWaterNeededAtSource,
      title: 'דרישת המים המירבית הדרושה במקור המים (חדר משאבות / רשת עירונית)'
    });
    this.sprinklerOffTimeRequirenments = new InspectionTimeCase({
      ...data.sprinklerOffTimeRequirenments,
      title: 'משך זמן כבוי נדרש בהתאם לדרישות התקן (min)'
    });
    this.requiredPoolingVolume = new InspectionWaterSupplyDataCase({
      ...data.requiredPoolingVolume,
      title: 'נפח איגום נדרש (m^3)'
    });
    this.floodingSystemOperationDescription = new InspectionCase({
      ...data.floodingSystemOperationDescription,
      title:
        'תאר את אופן הפעלת מערכת ההצפה (בהתאם למשטר ההפעלות שתכנן ע"י יועץ הבטיחות) מתזי ניווט, חשמלי או אחר'
    });
    this.hydraulicWaterRequirementMatchWaterSupplyDesign = new InspectionCase({
      ...data.hydraulicWaterRequirementMatchWaterSupplyDesign,
      title:
        'האם דרישת המים עפ"י החישובים ההידראולים מתאימה לנתוני מקור אספקת המים שתוכנן'
    });
  }
  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.deploymentAccordingSpec.isApplicable ||
        this.deploymentAccordingSpec.isPassed) &&
        (!this.pipingDesignType.isApplicable ||
          this.pipingDesignType.isPassed) &&
        (!this.maxWaterNeededAtMainStation.isApplicable ||
          this.maxWaterNeededAtMainStation.isPassed) &&
        (!this.maxWaterNeededAtSource.isApplicable ||
          this.maxWaterNeededAtSource.isPassed) &&
        (!this.sprinklerOffTimeRequirenments.isApplicable ||
          this.sprinklerOffTimeRequirenments.isPassed) &&
        (!this.requiredPoolingVolume.isApplicable ||
          this.requiredPoolingVolume.isPassed) &&
        (!this.floodingSystemOperationDescription.isApplicable ||
          this.floodingSystemOperationDescription.isPassed) &&
        (!this.hydraulicWaterRequirementMatchWaterSupplyDesign.isApplicable ||
          this.hydraulicWaterRequirementMatchWaterSupplyDesign.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.deploymentAccordingSpec.getNotes(),
      ...this.pipingDesignType.getNotes(),
      ...this.maxWaterNeededAtMainStation.getNotes(),
      ...this.maxWaterNeededAtSource.getNotes(),
      ...this.sprinklerOffTimeRequirenments.getNotes(),
      ...this.requiredPoolingVolume.getNotes(),
      ...this.floodingSystemOperationDescription.getNotes(),
      ...this.hydraulicWaterRequirementMatchWaterSupplyDesign.getNotes()
    ];
  }
}
